export class ReferenceNumberSource {
  type?: string;
  resourceId?: number;

  constructor(opts?: Partial<ReferenceNumberSource>) {
    if (opts?.type != null) {
      this.type = opts.type;
    }
    if (opts?.resourceId != null) {
      this.resourceId = opts.resourceId;
    }
  }
}
